function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-md-wallet"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M12.295 20.5v-9.844a2.461 2.461 0 0 1 2.462-2.463h11.359v-1.23A2.453 2.453 0 0 0 23.677 4.5H5.912a2.493 2.493 0 0 0-2.537 2.423v17.308a2.493 2.493 0 0 0 2.537 2.423h17.759a2.449 2.449 0 0 0 2.439-2.464v-1.228H14.751a2.46 2.46 0 0 1-2.456-2.462z",
    transform: "translate(-3.375 -3.577)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M17.227 12.886v8.16a.935.935 0 0 0 .933.933h10.9a.935.935 0 0 0 .933-.933v-8.16a.935.935 0 0 0-.933-.933h-10.9a.935.935 0 0 0-.933.933zm4.494 5.94a1.866 1.866 0 1 1 1.743-1.743 1.866 1.866 0 0 1-1.743 1.742z",
    transform: "translate(-5.992 -4.966)",
    style: {
      fill: "#ffffff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a0c998fd4177c22d0ccde20b34beff4e.svg";
export { ForwardRef as ReactComponent };